/*
 * School Management System API
 * APIs for managing branches, employees, students, receipts, etc.
 *
 * OpenAPI spec version: 1.0.0
 * Contact: tejabhargavpodila@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.54
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from "../ApiClient";
import DbGetRequest from '../model/DbGetRequest';
import DbUpdateRequest from '../model/DbUpdateRequest';
import Error from '../model/Error';
import Response from '../model/Response';

/**
* Db service.
* @module api/DbApi
* @version 1.0.0
*/
export default class DbApi {

    /**
    * Constructs a new DbApi. 
    * @alias module:api/DbApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the dbGet operation.
     * @callback moduleapi/DbApi~dbGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Response{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieve all data from database
     * Get a list of all data from database.
     * @param {Object} opts Optional parameters
     * @param {module:model/DbGetRequest} opts.body 
     * @param {module:api/DbApi~dbGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    dbGet(opts, callback) {
      opts = opts || {};
      let postBody = opts['body'];

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = Response;

      return this.apiClient.callApi(
        '/db/get', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the dbUpdate operation.
     * @callback moduleapi/DbApi~dbUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Response{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update data in database
     * Update data in database.
     * @param {Object} opts Optional parameters
     * @param {module:model/DbUpdateRequest} opts.body 
     * @param {module:api/DbApi~dbUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    dbUpdate(opts, callback) {
      opts = opts || {};
      let postBody = opts['body'];

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = Response;

      return this.apiClient.callApi(
        '/db/update', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getExcel operation.
     * @callback moduleapi/DbApi~getExcelCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Response{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieve all data from database
     * Get a list of all data from database.
     * @param {Object} opts Optional parameters
     * @param {module:model/DbGetRequest} opts.body 
     * @param {module:api/DbApi~getExcelCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getExcel(opts, callback) {
      opts = opts || {};
      let postBody = opts['body'];

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = Response;

      return this.apiClient.callApi(
        '/db/get_excel', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}